import { login, users,products,categories} from "../../utils/constants";
import { publicRequest } from "../../utils/requestMethods";
 export async  function getMessages() {
    return await publicRequest.get(users);
  }
  export async  function getOrders() {
    return await publicRequest.get(users);
  }
  export async  function getInvoices() {
    return await publicRequest.get(users);
  }
  export async  function getSales() {
    return await publicRequest.get(users);
  }
  export async  function getProducts() {
    return await publicRequest.get(products);
  }
  export async  function getCategories() {
    return await publicRequest.get(categories);
  }
  export  async  function editProductPost(data) {
    return await publicRequest.post(login,{
      username: "mor_2314",
      password: "83r5^_"
  });
  }
  export  async  function addProductPost(data) {
    return await publicRequest.post(login,{
      username: "mor_2314",
      password: "83r5^_"
  });
  }
  export  async  function editCategoryPost(data) {
    return await publicRequest.post(login,{
      username: "mor_2314",
      password: "83r5^_"
  });
  }
  export  async  function addCategoryPost(data) {
    return await publicRequest.post(login,{
      username: "mor_2314",
      password: "83r5^_"
  });
  }